import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./typeahead-searchgrid-widget.html';
import _ from 'lodash';

    

    function TypeAheadSearchgridWidget(params) {
        // Param settings
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        this.panelTemplate = params.panelTemplate;
        this.widgetSignals = params.widgetSignals;
        this.rowClickCallback = params.rowClickCallback;
        this.editMultipleCallback = params.editMultipleCallback;
        this.typeaheadOptions = ko.observable(params.typeaheadOptions);
        this.allowMultiSelection = ko.observable(_.isBoolean(params.allowMultiSelection) ? params.allowMultiSelection : true /*default*/);

        this.selectedIds = [];
        this.rowSelectionSubscriptions = [];

        var options = this.observableOptions();
        var savedFilters = options.filter;

        this.rows = ko.observableArray([]);
        this.allAcrossSelectedObs = ko.observable(false);
        this.flexQueryOptions = ko.observable({ WhereConditionObj : []});
        this.multiselect = ko.pureComputed(_.bind(function() {
            if (!this.allowMultiSelection()) {
                return false;
            }
            if (this.allAcrossSelectedObs()) {
                return true;
            }
            if (_.isEmpty(this.rows())) {
                return false;
            }
            // check to see if there's at least two selected
            var count = 0;
            _.forEach(this.rows(), function(row) {
                if (row._selected()) {
                    count++;
                }
                if (count > 1) {
                    // short-circuit the loop, we just need to know if it has more than one
                    return false;
                }
            });
            return count > 1;
        }, this));

        if (savedFilters && !_.isEmpty(savedFilters.search)) {
            this.flexQueryOptions({ WhereConditionObj : [{ conditions: savedFilters.search }] });
        }

        this.subscriptions = [
            this.flexQueryOptions.subscribe(_.bind(this.updateQuery, this)),
            this.allAcrossSelectedObs.subscribe(_.bind(this.allAcrossSelectedToggled, this)),
            this.observableData.subscribe(_.bind(this.refreshData, this))
        ];

        this.refreshData();
    }

    TypeAheadSearchgridWidget.prototype = {
        updateQuery: function(newValue) {
            var options = this.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            options.filter.search = _.get(newValue, 'WhereConditionObj[0].conditions', []);

            if (this.widgetSignals) {
                this.widgetSignals().dataRequested.dispatch();
            }
            this.observableOptions(options);
        },
        refreshData: function() {
            if (!ko.isObservable(this.observableData)) {
                return;
            }
            var data = this.observableData();
            if (_.isEmpty(data)) {
                return;
            }

            data.allAcrossSelectedObs = this.allAcrossSelectedObs;
            data.selectionEnabled = this.allowMultiSelection();

            this.clearRowSubscription();
            this.allRows = data.origlist;

            _.forEach(data.rows, _.bind(function(row) {
                row._actionCallback = _.bind(this.rowClicked, this, row);
                row._selected = ko.observable(_.includes(this.selectedIds, row.id));
                this.rowSelectionSubscriptions.push(row._selected.subscribe(_.bind(this.rowSelected, this, row)));
            }, this));
            this.rows(data.rows);
        },
        allAcrossSelectedToggled: function(allSelected) {
            this.selectedIds = _.map(allSelected ? this.allRows : this.rows(), 'id');
        },
        rowClicked: function(row, columnIndex) {
            if (_.isFunction(this.rowClickCallback)) {
                this.rowClickCallback(row, columnIndex);
            }
        },
        rowSelected: function(row, selected) {
            var foundIndex = _.indexOf(this.selectedIds, row.id);
            var inSelectedList = foundIndex >= 0;

            if (selected && !inSelectedList) {
                this.selectedIds.push(row.id);
            }
            else if (!selected && inSelectedList) {
                this.selectedIds.splice(foundIndex, 1);
            }
        },
        clearRowSubscription: function() {
            _.forEach(this.rowSelectionSubscriptions, function(sub) {
                sub.dispose();
            });
            this.rowSelectionSubscriptions = [];
        },
        edit: function() {
            if (_.isFunction(this.editMultipleCallback)) {
                this.editMultipleCallback(this.selectedIds);
            }
        }
    };


    export default { viewModel: TypeAheadSearchgridWidget, template: templateMarkup };

